import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {
    TotalStudents, TotalMealServed, TotalTransactions, TotalAlacarteServed, TotalRevenue,
    TotalInvoiceRevenue, TotalStudentsBySchoolBarchart
} from './DashboardItems'
import {
    getActiveSchoolYears, getActiveStudentsBySchoolYear,
    getTotalMeal_Alacarte_Transactions_revnueData, getTotalMeal_Alacarte_Transactions_revnueDataBySchoolYear
} from './dashboardItemsService';
import DateTimeRangePicker from '../../Misc/DateTimeRangePicker';
import reactga from 'react-ga';
import './dashboardItems.css';
import SchoolWiseTable from './DashboardItems/schoolWiseTable';
import { numberParce } from '../../../server/util';

class superAdminDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            schoolYears: {
                resp: [],
                selectedYear: '',
                latestActiveSy: '',
                loading: false
            },
            selectedDates: {
                startDate: moment().startOf('M'),
                endDate: moment().endOf('M')
            },
            totalStudents: {
                loading: false,
                data: {}
            },
            totalCountersData: {
                loading: false,
                data: {}
            },
        }
    };
    componentDidMount = () => {
        reactga.initialize('UA-123981741-1')
        //to report page view
        reactga.pageview('/sadminhome');
        this.getAllSchoolYears();
    }
    bindCharts = () => {
        this.getAllMeal_Alacarte_Transactions_revnueData();
        // this.getAllTransactionsData();
    }
    isCurrentSchoolYear = () => {
        const { schoolYears } = this.state;
        const _selectedSchoolYear = numberParce(schoolYears.selectedYear);
        if (_selectedSchoolYear == schoolYears.latestActiveSy) {
            return true;
        } else {
            return false;
        }
    }
    getAllStudentsData = () => {
        const { schoolYears, totalStudents } = this.state;
        try {
            totalStudents.loading = true;
            this.setState({ totalStudents: { ...totalStudents } })
            const promise = new Promise((resolve) => getActiveStudentsBySchoolYear({ schoolYear: schoolYears.selectedYear }).then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    totalStudents.loading = false;
                    totalStudents.data = data.resp;
                    this.setState({ totalStudents: { ...totalStudents } })
                } else {
                    throw Error(response.statusText);
                }
            })
                .catch((error) => {
                    totalStudents.loading = false;
                    this.setState({ totalStudents: { ...totalStudents } })
                    console.log(error.message);
                }));
        } catch (ex) {
            console.log(ex)
        }
    }
    getAllSchoolYears = () => {
        const { schoolYears } = this.state
        const _currentDate = moment().startOf('D').utc().format('YYYY-MM-DDThh:mm:ss');
        try {
            schoolYears.loading = true;
            this.setState({ schoolYears: { ...schoolYears } })
            const promise = new Promise((resolve) => getActiveSchoolYears({ sysDate: _currentDate }).then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    schoolYears.loading = false;
                    schoolYears.resp = data.resp;
                    schoolYears.selectedYear = data.latestActiveSy;
                    schoolYears.latestActiveSy = data.latestActiveSy;
                    this.setState({ schoolYears: { ...schoolYears } }, () => {
                        // this.getAllStudentsData();
                        //this.bindCharts();
                    })
                } else {
                    throw Error(response.statusText);
                }
            })
                .catch((error) => {
                    schoolYears.loading = false;
                    this.setState({ schoolYears: { ...schoolYears } }, () => {
                        // this.bindCharts();
                    })
                    console.log(error.message);
                }));
        } catch (ex) {
            console.log(ex)
        }
    }
    getAllMeal_Alacarte_Transactions_revnueData = () => {
        const { selectedDates, schoolYears, totalCountersData } = this.state;
        const _startDate = moment(selectedDates.startDate).startOf('D').utc().format('YYYY-MM-DDThh:mm:ss');
        const _endDate = moment(selectedDates.endDate).endOf('D').utc().format('YYYY-MM-DDThh:mm:ss');
        try {
            totalCountersData.loading = true;
            this.setState({ totalCountersData: { ...totalCountersData } })
            const promise = new Promise((resolve) => {
                let res;
                if (this.isCurrentSchoolYear()) {
                    res = getTotalMeal_Alacarte_Transactions_revnueData({
                        schoolYear: schoolYears.selectedYear,
                        startDate: _startDate,
                        endDate: _endDate
                    });
                }
                else {
                    res = getTotalMeal_Alacarte_Transactions_revnueDataBySchoolYear({ schoolYear: schoolYears.selectedYear })
                }

                res.then((response) => {
                    const { data } = response;
                    if (data.statusCode === 200) {
                        totalCountersData.loading = false;
                        totalCountersData.data = data.resp;
                        this.setState({ totalCountersData: { ...totalCountersData } })
                    } else {
                        throw Error(response.statusText);
                    }
                })
                    .catch((error) => {
                        totalCountersData.loading = false;
                        this.setState({ totalCountersData: { ...totalCountersData } })
                        console.log(error.message);
                    });
            });
        } catch (ex) {
            console.log(ex)
        }
    }

    render() {
        const { schoolYears, totalCountersData, totalStudents } = this.state;
        return (
            <div>
                <section>
                    <div className="container">
                        <div className="sectionTitle">
                            <h2>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <span>Super Admin Dashboard</span>
                                    </div>

                                    <div className='col-md-8 '>
                                        <form className='form-inline'>
                                            <div class="form-group pull-right">
                                                <label htmlFor='ddSchoolYear'>School Year:</label>
                                                <select id="ddSchoolYear" value={schoolYears.selectedYear} className='form-control' onChange={(e) => {
                                                    const { schoolYears } = this.state;
                                                    schoolYears.selectedYear = e.target.value;
                                                    this.setState({ schoolYears: { ...schoolYears } }, () => {
                                                        //this.getAllStudentsData();
                                                        //this.bindCharts()
                                                    });
                                                }}>
                                                    <option disabled>Select</option>
                                                    {
                                                        ((schoolYears || {}).resp || []).sort((a, b) => { return b - a }).map((year, k) => {
                                                            return <option key={k} value={year}>{year}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </h2>
                        </div>
                        <div id="dashboardItems">
                            <div className="row">
                                <div className='col-sm-6 col-md-3'>
                                    <TotalStudents data={totalStudents} />
                                    <TotalStudentsBySchoolBarchart data={totalStudents} />
                                </div>
                                <div className='col-sm-6 col-md-9'>
                                    <div className='panel'>
                                        <div className='panel-body'>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    {
                                                        this.isCurrentSchoolYear() ?
                                                            <div className="pull-right" style={{ fontSize: '20px' }}>
                                                                <DateTimeRangePicker startDate={this.state.selectedDates.startDate}
                                                                    endDate={this.state.selectedDates.endDate}
                                                                    ranges={{
                                                                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                                                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                                                        'This Year': [moment().startOf('year'), moment().endOf('year')],
                                                                        'Last Year': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
                                                                    }}
                                                                    applyCallback={(event, picker) => {
                                                                        const _selectedDates = { ...this.state.selectedDates };
                                                                        _selectedDates.startDate = picker.startDate;
                                                                        _selectedDates.endDate = picker.endDate;
                                                                        this.setState({
                                                                            selectedDates: _selectedDates
                                                                        }, () => {
                                                                            //this.bindCharts();
                                                                        })
                                                                    }}
                                                                    isDateShow={false} />
                                                            </div> : null
                                                    }

                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-sm-6 col-md-4'>
                                                    <TotalMealServed data={totalCountersData} />
                                                </div>
                                                <div className='col-sm-6 col-md-4'>
                                                    <TotalAlacarteServed data={totalCountersData} />
                                                </div>
                                                <div className='col-sm-6 col-md-4'>
                                                    <TotalTransactions data={totalCountersData} />
                                                </div>
                                                <div className='col-sm-6 col-md-4'>
                                                    <TotalRevenue data={totalCountersData} />
                                                </div>
                                                <div className='col-sm-6 col-md-4'>
                                                    <TotalInvoiceRevenue data={totalCountersData} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    {/*  <SchoolWiseTable data={this.state} /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default superAdminDashboard;




// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/superAdminDashboard.jsx